import react, { useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import DoneRow from "./DoneRow";
import jMoment from "moment-jalaali";
import Pagination from "@mui/material/Pagination";

const DoneTable = (props) => {
  const [page, setPage] = useState(1);
  const handleChange = (event, value) => {
    setPage(value);
    props.getPage(value);
  };
  return (
    <Box>
      <TableContainer component={Paper} sx={{ mt: 1 }}>
        <Table>
          <TableHead>
            <TableRow variant="head">
              <TableCell align="center" />
              <TableCell align="center" style={{ fontSize: 18 }}>
                شماره جعبه
              </TableCell>
              <TableCell align="center" style={{ fontSize: 18 }}>
                تاریخ شروع
              </TableCell>
              <TableCell align="center" style={{ fontSize: 18 }}>
                نام بیمار
              </TableCell>
              <TableCell align="center" style={{ fontSize: 18 }}>
                نام پزشک
              </TableCell>
              <TableCell align="center" style={{ fontSize: 18 }}>
                نوع کار
              </TableCell>
              <TableCell align="center" style={{ fontSize: 18 }}>
                اتمام{" "}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {props.data.map((order) => {
              return (
                <DoneRow
                  key={order.id}
                  orderId={order.id}
                  startDate={jMoment(Number(order.startDate)).format(
                    "jYY/jMM/jDD",
                  )}
                  boxNumber={order.boxNumber}
                  patientName={order.patientName}
                  doctorName={order.doctorName}
                  orderType={order.orderType}
                  lastExit={jMoment(Number(order.lastExit)).format(
                    "jYY/jMM/jDD",
                  )}
                />
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <Pagination
        sx={{ mt: 4, justifyContent: "center", display: "flex" }}
        count={props.pageCount}
        // page={page}
        onChange={handleChange}
      />
    </Box>
  );
};

export default DoneTable;
